
import { t } from "@/composables/translateText.js";

var idMap = null
var nameMap = null

const puzzleCategories = [
  {
    "id": "0",
    "name": "all",
    "shortname": "All",
    "longname": "Includes every puzzle"
  },
  {
    "id": "1",
    "name": "advantage",
    "shortname": "Advantage",
    "longname": "Seize your chance to get a decisive advantage. (200cp <= eval <= 600cp)"
  },
  {
    "id": "2",
    "name": "endgame",
    "shortname": "Endgame",
    "longname": "A tactic during the last phase of the game."
  },
  {
    "id": "3",
    "name": "twomove",
    "shortname": "2 move puzzle",
    "longname": "Two moves to win."
  },
  {
    "id": "4",
    "name": "middlegame",
    "shortname": "Middlegame",
    "longname": "A tactic during the second phase of the game."
  },
  {
    "id": "5",
    "name": "advancedpawn",
    "shortname": "Advanced pawn",
    "longname": "One of your pawns is deep into the opponent position, maybe threatening to promote."
  },
  {
    "id": "6",
    "name": "crushing",
    "shortname": "Crushing",
    "longname": "Spot the opponent blunder to obtain a crushing advantage. (eval >= 600cp)"
  },
  {
    "id": "7",
    "name": "trappedpiece",
    "shortname": "Trapped piece",
    "longname": "A piece is unable to escape capture as it has limited moves."
  },
  {
    "id": "8",
    "name": "pin",
    "shortname": "Pin",
    "longname": "A tactic involving pins, where a piece is unable to move without revealing an attack on a higher value piece."
  },
  {
    "id": "9",
    "name": "hangingpiece",
    "shortname": "Hanging piece",
    "longname": "A tactic involving an opponent piece being undefended or insufficiently defended and free to capture."
  },
  {
    "id": "10",
    "name": "opening",
    "shortname": "Opening",
    "longname": "A tactic during the first phase of the game."
  },
  {
    "id": "11",
    "name": "discoveredattack",
    "shortname": "Discovered attack",
    "longname": "Moving a piece that previously blocked an attack by another long range piece, such as a knight out of the way of a rook."
  },
  {
    "id": "12",
    "name": "onemove",
    "shortname": "1 move puzzle",
    "longname": "A puzzle that is only one move long."
  },
  {
    "id": "13",
    "name": "fork",
    "shortname": "Fork",
    "longname": "A move where the moved piece attacks two opponent pieces at once."
  },
  {
    "id": "14",
    "name": "threemove",
    "shortname": "3 move puzzle",
    "longname": "Three moves to win."
  },
  {
    "id": "15",
    "name": "verylong",
    "shortname": "4+ move puzzle",
    "longname": "Four moves or more to win."
  },
  {
    "id": "16",
    "name": "exposedking",
    "shortname": "Exposed king",
    "longname": "A tactic involving a king with few defenders around it, often leading to checkmate."
  },
  {
    "id": "17",
    "name": "skewer",
    "shortname": "Skewer",
    "longname": "A motif involving a high value piece being attacked, moving out the way, and allowing a lower value piece behind it to be captured or attacked, the inverse of a pin."
  },
  {
    "id": "18",
    "name": "kingsideattack",
    "shortname": "Kingside attack",
    "longname": "An attack of the opponent's king, after they castled on the king side."
  },
  {
    "id": "19",
    "name": "rookendgame",
    "shortname": "Rook endgame",
    "longname": "An endgame with only rooks and pawns."
  },
  {
    "id": "20",
    "name": "mate",
    "shortname": "Mate",
    "longname": "All checkmate puzzles combined"
  },
  {
    "id": "21",
    "name": "matein1",
    "shortname": "1 move mate",
    "longname": "Checkmate in 1 move"
  },
  {
    "id": "22",
    "name": "defensivemove",
    "shortname": "Defensive move",
    "longname": "A precise move or sequence of moves that is needed to avoid losing material or another advantage."
  },
  {
    "id": "23",
    "name": "backrankmate",
    "shortname": "Back rank mate",
    "longname": "Checkmate the king on the home rank, when it is trapped there by its own pieces."
  },
  {
    "id": "24",
    "name": "matein2",
    "shortname": "2 move mate",
    "longname": "Checkmate in 2 moves"
  },
  {
    "id": "25",
    "name": "equality",
    "shortname": "Equality",
    "longname": "Come back from a losing position, and secure a draw or a balanced position. (eval >= 200cp)"
  },
  {
    "id": "26",
    "name": "sacrifice",
    "shortname": "Sacrifice",
    "longname": "A tactic involving giving up material in the short-term, to gain an advantage again after a forced sequence of moves."
  },
  {
    "id": "27",
    "name": "pawnendgame",
    "shortname": "Pawn endgame",
    "longname": "An endgame with only pawns."
  },
  {
    "id": "28",
    "name": "intermezzo",
    "shortname": "Intermezzo",
    "longname": "Instead of playing the expected move, first interpose another move posing an immediate threat that the opponent must answer. Also known as 'Zwischenzug' or 'In between'."
  },
  {
    "id": "29",
    "name": "deflection",
    "shortname": "Deflection",
    "longname": "A move that distracts an opponent piece from another duty that it performs, such as guarding a key square. Sometimes also called 'overloading'."
  },
  {
    "id": "30",
    "name": "xrayattack",
    "shortname": "X-Ray attack",
    "longname": "A piece attacks or defends a square, through an enemy piece."
  },
  {
    "id": "31",
    "name": "capturingdefender",
    "shortname": "Capture the defender",
    "longname": "Removing a piece that is critical to defence of another piece, allowing the now undefended piece to be captured on a following move."
  },
  {
    "id": "32",
    "name": "queenendgame",
    "shortname": "Queen endgame",
    "longname": "An endgame with only queens and pawns."
  },
  {
    "id": "33",
    "name": "attraction",
    "shortname": "Attraction",
    "longname": "An exchange or sacrifice encouraging or forcing an opponent piece to a square that allows a follow-up tactic."
  },
  {
    "id": "34",
    "name": "quietmove",
    "shortname": "Quiet move",
    "longname": "A move that does not make a check or capture, but does prepare an unavoidable threat for a later move."
  },
  {
    "id": "35",
    "name": "knightendgame",
    "shortname": "Knight endgame",
    "longname": "An endgame with only knights and pawns."
  },
  {
    "id": "36",
    "name": "matein3",
    "shortname": "3 move mate",
    "longname": "Checkmate in 3 moves"
  },
  {
    "id": "37",
    "name": "clearance",
    "shortname": "Clearance",
    "longname": "A move, often with tempo, that clears a square, file or diagonal for a follow-up tactical idea."
  },
  {
    "id": "38",
    "name": "bishopendgame",
    "shortname": "Bishop endgame",
    "longname": "An endgame with only bishops and pawns."
  },
  {
    "id": "39",
    "name": "promotion",
    "shortname": "Promotion",
    "longname": "Promote one of your pawns to a queen or minor piece."
  },
  {
    "id": "40",
    "name": "queenrookendgame",
    "shortname": "Queen and Rook",
    "longname": "An endgame with only queens, rooks and pawns."
  },
  {
    "id": "41",
    "name": "interference",
    "shortname": "Interference",
    "longname": "Moving a piece between two opponent pieces to leave one or both opponent pieces undefended, such as a knight on a defended square between two rooks."
  },
  {
    "id": "42",
    "name": "queensideattack",
    "shortname": "Queenside attack",
    "longname": "An attack of the opponent's king, after they castled on the queen side."
  },
  {
    "id": "43",
    "name": "doublecheck",
    "shortname": "Double check",
    "longname": "Checking with two pieces at once, as a result of a discovered attack where both the moving piece and the unveiled piece attack the opponent's king."
  },
  {
    "id": "44",
    "name": "smotheredmate",
    "shortname": "Smothered mate",
    "longname": "A checkmate delivered by a knight in which the mated king is unable to move because it is surrounded (or smothered) by its own pieces."
  },
  {
    "id": "45",
    "name": "zugzwang",
    "shortname": "Zugzwang",
    "longname": "The opponent is limited in the moves they can make, and all moves worsen their position."
  },
  {
    "id": "46",
    "name": "enpassant",
    "shortname": "En Passant",
    "longname": "A tactic involving the en passant rule, where a pawn can capture an opponent pawn that has bypassed it using its initial two-square move."
  },
  {
    "id": "47",
    "name": "castling",
    "shortname": "Castling",
    "longname": "Bring the king to safety, and deploy the rook for attack."
  },
  {
    "id": "48",
    "name": "attackingf2f7",
    "shortname": "Attacking f2 or f7",
    "longname": "An attack focusing on the f2 or f7 pawn, such as in the fried liver opening."
  },
  {
    "id": "49",
    "name": "matein4",
    "shortname": "4 move mate",
    "longname": "Checkmate in 4 moves"
  },
  {
    "id": "50",
    "name": "matein5",
    "shortname": "5+ move mate",
    "longname": "Checkmate in 5 or more move"
  },
  {
    "id": "51",
    "name": "underpromotion",
    "shortname": "Underpromotion",
    "longname": "Promotion to a knight, bishop, or rook."
  },
  {
    "id": "52",
    "name": "master",
    "shortname": "Master games",
    "longname": "Puzzles from games played by titled players."
  },
  {
    "id": "53",
    "name": "mastervsmaster",
    "shortname": "Master vs Master games",
    "longname": "Puzzles from games between two titled players."
  },
  {
    "id": "54",
    "name": "supergm",
    "shortname": "Super GM games",
    "longname": "Puzzles from games played by the best players in the world."
  },
  {
    "id": "55",
    "name": "hookmate",
    "shortname": "Hook mate",
    "longname": "Checkmate with a rook, knight, and pawn along with one enemy pawn to limit the enemy king's escape."
  },
  {
    "id": "56",
    "name": "anastasiamate",
    "shortname": "Anastasia's mate",
    "longname": "A knight and rook or queen team up to trap the opposing king between the side of the board and a friendly piece."
  },
  {
    "id": "57",
    "name": "arabianmate",
    "shortname": "Arabian mate",
    "longname": "A knight and a rook team up to trap the opposing king on a corner of the board."
  },
  {
    "id": "58",
    "name": "dovetailmate",
    "shortname": "Dovetail mate",
    "longname": "A queen delivers mate to an adjacent king, whose only two escape squares are obstructed by friendly pieces."
  },
  {
    "id": "59",
    "name": "bodenmate",
    "shortname": "Boden's mate",
    "longname": "Two attacking bishops on criss-crossing diagonals deliver mate to a king obstructed by friendly pieces."
  },
  {
    "id": "60",
    "name": "doublebishopmate",
    "shortname": "Double bishop mate",
    "longname": "Two attacking bishops on adjacent diagonals deliver mate to a king obstructed by friendly pieces."
  },
  {
    "id": "61",
    "name": "vukovicmate",
    "shortname": "Vukovic Mate",
    "longname": "Vukovic Mate"
  },
  {
    "id": "62",
    "name": "killboxmate",
    "shortname": "Killbox Mate",
    "longname": "A rook is next to the enemy king and supported by a queen that also blocks the king's escape squares. The rook and the queen catch the enemy king in a 3 by 3 'kill box'."
  },
  {
    "id": "102",
    "name": "alekhine_defense",
    "shortname": "Alekhine Defense",
    "longname": "Alekhine Defense"
  },
  {
    "id": "103",
    "name": "benoni_defense",
    "shortname": "Benoni Defense",
    "longname": "Benoni Defense"
  },
  {
    "id": "104",
    "name": "bird_opening",
    "shortname": "Bird Opening",
    "longname": "Bird Opening"
  },
  {
    "id": "105",
    "name": "bishops_opening",
    "shortname": "Bishops Opening",
    "longname": "Bishops Opening"
  },
  {
    "id": "106",
    "name": "blackmar-diemer_gambit",
    "shortname": "Blackmar-Diemer Gambit",
    "longname": "Blackmar-Diemer Gambit"
  },
  {
    "id": "107",
    "name": "caro-kann_defense",
    "shortname": "Caro-Kann Defense",
    "longname": "Caro-Kann Defense"
  },
  {
    "id": "108",
    "name": "catalan_opening",
    "shortname": "Catalan Opening",
    "longname": "Catalan Opening"
  },
  {
    "id": "109",
    "name": "center_game",
    "shortname": "Center Game",
    "longname": "Center Game"
  },
  {
    "id": "110",
    "name": "danish_gambit",
    "shortname": "Danish Gambit",
    "longname": "Danish Gambit"
  },
  {
    "id": "111",
    "name": "danish_gambit_accepted",
    "shortname": "Danish Gambit Accepted",
    "longname": "Danish Gambit Accepted"
  },
  {
    "id": "112",
    "name": "dutch_defense",
    "shortname": "Dutch Defense",
    "longname": "Dutch Defense"
  },
  {
    "id": "113",
    "name": "elephant_gambit",
    "shortname": "Elephant Gambit",
    "longname": "Elephant Gambit"
  },
  {
    "id": "114",
    "name": "english_defense",
    "shortname": "English Defense",
    "longname": "English Defense"
  },
  {
    "id": "115",
    "name": "english_opening",
    "shortname": "English Opening",
    "longname": "English Opening"
  },
  {
    "id": "116",
    "name": "englund_gambit",
    "shortname": "Englund Gambit",
    "longname": "Englund Gambit"
  },
  {
    "id": "117",
    "name": "englund_gambit_complex",
    "shortname": "Englund Gambit Complex",
    "longname": "Englund Gambit Complex"
  },
  {
    "id": "118",
    "name": "englund_gambit_declined",
    "shortname": "Englund Gambit Declined",
    "longname": "Englund Gambit Declined"
  },
  {
    "id": "119",
    "name": "four_knights_game",
    "shortname": "Four Knights Game",
    "longname": "Four Knights Game"
  },
  {
    "id": "120",
    "name": "french_defense",
    "shortname": "French Defense",
    "longname": "French Defense"
  },
  {
    "id": "121",
    "name": "grob_opening",
    "shortname": "Grob Opening",
    "longname": "Grob Opening"
  },
  {
    "id": "122",
    "name": "grunfeld_defense",
    "shortname": "Grunfeld Defense",
    "longname": "Grunfeld Defense"
  },
  {
    "id": "123",
    "name": "horwitz_defense",
    "shortname": "Horwitz Defense",
    "longname": "Horwitz Defense"
  },
  {
    "id": "124",
    "name": "hungarian_opening",
    "shortname": "Hungarian Opening",
    "longname": "Hungarian Opening"
  },
  {
    "id": "125",
    "name": "indian_defense",
    "shortname": "Indian Defense",
    "longname": "Indian Defense"
  },
  {
    "id": "126",
    "name": "italian_game",
    "shortname": "Italian Game",
    "longname": "Italian Game"
  },
  {
    "id": "127",
    "name": "kings_gambit",
    "shortname": "Kings Gambit",
    "longname": "Kings Gambit"
  },
  {
    "id": "128",
    "name": "kings_gambit_accepted",
    "shortname": "Kings Gambit Accepted",
    "longname": "Kings Gambit Accepted"
  },
  {
    "id": "129",
    "name": "kings_gambit_declined",
    "shortname": "Kings Gambit Declined",
    "longname": "Kings Gambit Declined"
  },
  {
    "id": "130",
    "name": "kings_indian_attack",
    "shortname": "Kings Indian Attack",
    "longname": "Kings Indian Attack"
  },
  {
    "id": "131",
    "name": "kings_indian_defense",
    "shortname": "Kings Indian Defense",
    "longname": "Kings Indian Defense"
  },
  {
    "id": "132",
    "name": "kings_knight_opening",
    "shortname": "Kings Knight Opening",
    "longname": "Kings Knight Opening"
  },
  {
    "id": "133",
    "name": "kings_pawn_game",
    "shortname": "Kings Pawn Game",
    "longname": "Kings Pawn Game"
  },
  {
    "id": "134",
    "name": "london_system",
    "shortname": "London System",
    "longname": "London System"
  },
  {
    "id": "135",
    "name": "mieses_opening",
    "shortname": "Mieses Opening",
    "longname": "Mieses Opening"
  },
  {
    "id": "136",
    "name": "modern_defense",
    "shortname": "Modern Defense",
    "longname": "Modern Defense"
  },
  {
    "id": "137",
    "name": "nimzo-indian_defense",
    "shortname": "Nimzo-Indian Defense",
    "longname": "Nimzo-Indian Defense"
  },
  {
    "id": "138",
    "name": "nimzo-larsen_attack",
    "shortname": "Nimzo-Larsen Attack",
    "longname": "Nimzo-Larsen Attack"
  },
  {
    "id": "139",
    "name": "nimzowitsch_defense",
    "shortname": "Nimzowitsch Defense",
    "longname": "Nimzowitsch Defense"
  },
  {
    "id": "140",
    "name": "old_indian_defense",
    "shortname": "Old Indian Defense",
    "longname": "Old Indian Defense"
  },
  {
    "id": "141",
    "name": "owen_defense",
    "shortname": "Owen Defense",
    "longname": "Owen Defense"
  },
  {
    "id": "142",
    "name": "philidor_defense",
    "shortname": "Philidor Defense",
    "longname": "Philidor Defense"
  },
  {
    "id": "143",
    "name": "pirc_defense",
    "shortname": "Pirc Defense",
    "longname": "Pirc Defense"
  },
  {
    "id": "144",
    "name": "polish_opening",
    "shortname": "Polish Opening",
    "longname": "Polish Opening"
  },
  {
    "id": "145",
    "name": "ponziani_opening",
    "shortname": "Ponziani Opening",
    "longname": "Ponziani Opening"
  },
  {
    "id": "146",
    "name": "queens_gambit_accepted",
    "shortname": "Queens Gambit Accepted",
    "longname": "Queens Gambit Accepted"
  },
  {
    "id": "147",
    "name": "queens_gambit_declined",
    "shortname": "Queens Gambit Declined",
    "longname": "Queens Gambit Declined"
  },
  {
    "id": "148",
    "name": "queens_indian_defense",
    "shortname": "Queens Indian Defense",
    "longname": "Queens Indian Defense"
  },
  {
    "id": "149",
    "name": "queens_pawn_game",
    "shortname": "Queens Pawn Game",
    "longname": "Queens Pawn Game"
  },
  {
    "id": "150",
    "name": "rapport-jobava_system",
    "shortname": "Rapport-Jobava System",
    "longname": "Rapport-Jobava System"
  },
  {
    "id": "151",
    "name": "rat_defense",
    "shortname": "Rat Defense",
    "longname": "Rat Defense"
  },
  {
    "id": "152",
    "name": "reti_opening",
    "shortname": "Reti Opening",
    "longname": "Reti Opening"
  },
  {
    "id": "153",
    "name": "russian_game",
    "shortname": "Russian Game",
    "longname": "Russian Game"
  },
  {
    "id": "154",
    "name": "ruy_lopez",
    "shortname": "Ruy Lopez",
    "longname": "Ruy Lopez"
  },
  {
    "id": "155",
    "name": "scandinavian_defense",
    "shortname": "Scandinavian Defense",
    "longname": "Scandinavian Defense"
  },
  {
    "id": "156",
    "name": "scotch_game",
    "shortname": "Scotch Game",
    "longname": "Scotch Game"
  },
  {
    "id": "157",
    "name": "semi-slav_defense",
    "shortname": "Semi-Slav Defense",
    "longname": "Semi-Slav Defense"
  },
  {
    "id": "158",
    "name": "sicilian_defense",
    "shortname": "Sicilian Defense",
    "longname": "Sicilian Defense"
  },
  {
    "id": "159",
    "name": "slav_defense",
    "shortname": "Slav Defense",
    "longname": "Slav Defense"
  },
  {
    "id": "160",
    "name": "tarrasch_defense",
    "shortname": "Tarrasch Defense",
    "longname": "Tarrasch Defense"
  },
  {
    "id": "161",
    "name": "three_knights_opening",
    "shortname": "Three Knights Opening",
    "longname": "Three Knights Opening"
  },
  {
    "id": "162",
    "name": "trompowsky_attack",
    "shortname": "Trompowsky Attack",
    "longname": "Trompowsky Attack"
  },
  {
    "id": "163",
    "name": "van_geet_opening",
    "shortname": "Van Geet Opening",
    "longname": "Van Geet Opening"
  },
  {
    "id": "164",
    "name": "vant_kruijs_opening",
    "shortname": "Vant Kruijs Opening",
    "longname": "Vant Kruijs Opening"
  },
  {
    "id": "165",
    "name": "vienna_game",
    "shortname": "Vienna Game",
    "longname": "Vienna Game"
  },
  {
    "id": "166",
    "name": "zukertort_opening",
    "shortname": "Zukertort Opening",
    "longname": "Zukertort Opening"
  },
  {
    "id": "203",
    "name": "pieces3",
    "shortname": "3 Pieces",
    "longname": "Boards with 3 Pieces"
  },
  {
    "id": "204",
    "name": "pieces4",
    "shortname": "4 Pieces",
    "longname": "Boards with 4 Pieces"
  },
  {
    "id": "205",
    "name": "pieces5",
    "shortname": "5 Pieces",
    "longname": "Boards with 5 Pieces"
  },
  {
    "id": "206",
    "name": "pieces6",
    "shortname": "6 Pieces",
    "longname": "Boards with 6 Pieces"
  },
  {
    "id": "207",
    "name": "pieces7",
    "shortname": "7 Pieces",
    "longname": "Boards with 7 Pieces"
  },
  {
    "id": "208",
    "name": "pieces8",
    "shortname": "8 Pieces",
    "longname": "Boards with 8 Pieces"
  },
  {
    "id": "209",
    "name": "pieces9",
    "shortname": "9 Pieces",
    "longname": "Boards with 9 Pieces"
  },
  {
    "id": "210",
    "name": "pieces10",
    "shortname": "10 Pieces",
    "longname": "Boards with 10 Pieces"
  },
  {
    "id": "211",
    "name": "pieces11",
    "shortname": "11 Pieces",
    "longname": "Boards with 11 Pieces"
  },
  {
    "id": "212",
    "name": "pieces12",
    "shortname": "12 Pieces",
    "longname": "Boards with 12 Pieces"
  },
  {
    "id": "213",
    "name": "pieces13",
    "shortname": "13 Pieces",
    "longname": "Boards with 13 Pieces"
  },
  {
    "id": "214",
    "name": "pieces14",
    "shortname": "14 Pieces",
    "longname": "Boards with 14 Pieces"
  },
  {
    "id": "215",
    "name": "pieces15",
    "shortname": "15 Pieces",
    "longname": "Boards with 15 Pieces"
  },
  {
    "id": "216",
    "name": "pieces16",
    "shortname": "16 Pieces",
    "longname": "Boards with 16 Pieces"
  },
  {
    "id": "217",
    "name": "pieces17",
    "shortname": "17 Pieces",
    "longname": "Boards with 17 Pieces"
  },
  {
    "id": "218",
    "name": "pieces18",
    "shortname": "18 Pieces",
    "longname": "Boards with 18 Pieces"
  },
  {
    "id": "219",
    "name": "pieces19",
    "shortname": "19 Pieces",
    "longname": "Boards with 19 Pieces"
  },
  {
    "id": "220",
    "name": "pieces20",
    "shortname": "20 Pieces",
    "longname": "Boards with 20 Pieces"
  },
  {
    "id": "221",
    "name": "pieces21",
    "shortname": "21 Pieces",
    "longname": "Boards with 21 Pieces"
  },
  {
    "id": "222",
    "name": "pieces22",
    "shortname": "22 Pieces",
    "longname": "Boards with 22 Pieces"
  },
  {
    "id": "223",
    "name": "pieces23",
    "shortname": "23 Pieces",
    "longname": "Boards with 23 Pieces"
  },
  {
    "id": "224",
    "name": "pieces24",
    "shortname": "24 Pieces",
    "longname": "Boards with 24 Pieces"
  },
  {
    "id": "225",
    "name": "pieces25",
    "shortname": "25 Pieces",
    "longname": "Boards with 25 Pieces"
  },
  {
    "id": "226",
    "name": "pieces26",
    "shortname": "26 Pieces",
    "longname": "Boards with 26 Pieces"
  },
  {
    "id": "227",
    "name": "pieces27",
    "shortname": "27 Pieces",
    "longname": "Boards with 27 Pieces"
  },
  {
    "id": "228",
    "name": "pieces28",
    "shortname": "28 Pieces",
    "longname": "Boards with 28 Pieces"
  },
  {
    "id": "229",
    "name": "pieces29",
    "shortname": "29 Pieces",
    "longname": "Boards with 29 Pieces"
  },
  {
    "id": "230",
    "name": "pieces30",
    "shortname": "30 Pieces",
    "longname": "Boards with 30 Pieces"
  },
  {
    "id": "231",
    "name": "pieces31",
    "shortname": "31 Pieces",
    "longname": "Boards with 31 Pieces"
  },
  {
    "id": "232",
    "name": "pieces32",
    "shortname": "32 Pieces",
    "longname": "Boards with 32 Pieces"
  },
  {
    "id": "250",
    "name": "do_over",
    "shortname": "Do over",
    "longname": "Puzzles you tried again."
  },
  {
    "id": "251",
    "name": "newbies",
    "shortname": "New puzzles",
    "longname": "New or unpopular puzzles."
  }
]

/*

  {
    "id": "0",
    "name": "all",
    "shortname": "All",
    "longname": "Includes every puzzle"
  },

*/

export function findPuzzleCategoryByName(name) {

  // build map on first request
  if (nameMap == null) {
    nameMap = new Map()
    for (var i=0; i < puzzleCategories.length; i++)
      nameMap.set(puzzleCategories[i].name,puzzleCategories[i])
  }
  //console.log(nameMap)
  const category = nameMap.get(name)
  //console.log("category lookup",name,category)
  if (category == null)
    return (null)
  return (category)
}

export function puzzleCategoryBuilder(catidArray,countArray,favoriteArray,valueToFind) {
  var displayToFind = ""
  var tempCountMap = new Map()

  var favoriteMap = new Map()
  
  for (var i=0; i < favoriteArray.length; i++)
    favoriteMap.set(Number(favoriteArray[i]),"a")

  for (var i=0; i < catidArray.length; i++) {
    const catid = catidArray[i]
    const count = Number(countArray[i])
    tempCountMap.set(catid,count)
  }
  var optionDisplayArray = []
  var categoryMap = new Map()

  for (var i=0; i < puzzleCategories.length; i++) {

    const oneCatName = puzzleCategories[i]

    var puzzleCount = tempCountMap.get(oneCatName.id)
    if (puzzleCount == null)
      puzzleCount = 0

    // is it a favorite?
    const favoriteEntry = favoriteMap.get(Number(oneCatName.id))

    const puzzleCountPretty = puzzleCount.toLocaleString()
    const shortName = t(oneCatName.shortname)
    const displayName =  shortName + " (" + puzzleCountPretty + ") -- " + t(oneCatName.longname)
    if (valueToFind == oneCatName.id)
      displayToFind = displayName
    const oneItem = { 
      index : i,
      abbreviation : oneCatName.name,
      name : displayName,
      shortName : shortName,
      id : oneCatName.id,
      favorite : (favoriteEntry == "a"),
      radio : "" + oneCatName.id
    }
    //console.log("one item",oneItem)
    optionDisplayArray.push(oneItem)
    categoryMap.set(oneCatName.name,oneItem)
  }
  return ( { map : categoryMap, display : optionDisplayArray, displayToFind : displayToFind })
}

export function puzzleVisualizeBuilder(valueToFind) {
  var displayToFind = ""
  const noMoves = t("No Visualized Moves")
  const halfMove = t("1 Opponent Move - 1 Half Move")
  const moveLabel = t("Move")
  const movesLabel = t("Moves")
  const fullLabel = t("Full")

  var displays = []
  var values = []

  displays.push(noMoves)
  if (valueToFind == 0)
    displayToFind = noMoves
  values.push(0)
  displays.push(halfMove)
  if (valueToFind == 1)
    displayToFind = halfMove
  values.push(1)
  const oneMoveDisplay = "1 " + fullLabel + " " + moveLabel
  displays.push(oneMoveDisplay)
  if (valueToFind == 2)
    displayToFind = oneMoveDisplay
  values.push(2)
  for (var i=4,j = 2; i <= 20; i += 2,j++) {
    const movesDisplay = j + " " + fullLabel + " " + movesLabel
    displays.push(movesDisplay)
    if (i == valueToFind)
      displayToFind = movesDisplay
    values.push(i)
  }
  return { display : displays, value : values , displayToFind : displayToFind}
}

export function puzzleTimeControlBuilder(valueToFind) {
  var displayToFind = ""
  const times = [
      { base : 5, increment : 0 },
      { base : 10, increment : 0 },
      { base : 15, increment : 0 },
      { base : 20, increment : 0 },
      { base : 30, increment : 0 },
      { base : 60, increment : 0 },
      { base : 5, increment : 5 },
      { base : 10, increment : 5 },
      { base : 15, increment : 5 },
      { base : 20, increment : 5 },
      { base : 30, increment : 10 },
      { base : 60, increment : 10 },
      { base : 120, increment : 0 },
      { base : 180, increment : 0 },
      { base : 240, increment : 0 }
  ]

  var displays = []
  var values = []
  const secondsString = t("Seconds")
  for (var i=0; i < times.length; i++) {
    const display = (times[i].increment == 0) ? times[i].base + " " + secondsString :
              times[i].base + " + " + times[i].increment + " " + secondsString
    const value = times[i].base * 100 + times[i].increment

    if (valueToFind == value)
      displayToFind = display
    displays.push(display)
    values.push(value)
  }
  return { display : displays, value : values, displayToFind : displayToFind }
}

export function puzzleWhenTimerStartsBuilder(valueToFind) {

  //console.log("time starts ",valueToFind)
  var displayToFind = ""
  const whenStarts = [
    { display : t("Immediately When Puzzle Shown"),  value : 0},
    { display : t("After First Move"),  value : 1}
  ]

  var displays = [ whenStarts[0].display, whenStarts[1].display]
  var values = [ whenStarts[0].value, whenStarts[1].value]

  if (valueToFind == whenStarts[0].value)
    displayToFind = whenStarts[0].display
  else
    if (valueToFind == whenStarts[1].value)
      displayToFind = whenStarts[1].display

  return { display : displays, value : values, displayToFind : displayToFind }

}

export function puzzleBlindfoldBuilder(valueToFind) {
  var displayToFind = ""
  const blindfolds = [
    { display : t("One Color Pieces"),  value : 2},
    { display : t("Two Color Discs"),  value : 3},
    { display : t("One Color Disc"),  value : 4},
    { display : t("Empty Board"),  value : 5},
  ]

  var displays = []
  var values = []
  for (var i=0; i < blindfolds.length; i++) {
    if (blindfolds[i].value == valueToFind)
      displayToFind = blindfolds[i].display
    displays.push(blindfolds[i].display)
    values.push(blindfolds[i].value)
  }
  return { display : displays, value : values, displayToFind : displayToFind }

}

export function puzzleAccordionBuilder(isSubscriber,categoryMap,optionDisplaySelected) {
  const favoritesHeading = (isSubscriber) ? t("Favorites") : t("Favorites (subscriber benefit)")
  
  var accordionLabels = [
    { index : 0, value : "favorites", label : favoritesHeading,
                      mustBeSubscriber:true, categories : []},
    { index : 1, value : "all", label : t("All"), initialOpen : false,
              categories : [ "all"
              ]},
    { index : 2, value : "phases", label : t("Phases"), initialOpen : false,
              categories : [ "opening", "middlegame", "endgame", "rookEndgame", "bishopEndgame",
                "pawnEndgame", "knightEndgame", "queenEndgame", "queenRookEndgame"
              ]},
    { index : 3, value : "motifs", label : t("Motifs"), initialOpen : false,
              categories : [ "advancedPawn", "attackingF2F7", "capturingDefender",
                "discoveredAttack", "doubleCheck", "exposedKing", "fork", 
                "hangingPiece", "kingsideAttack", "pin", "queensideAttack", 
                "sacrifice", "skewer", "trappedPiece"
              ]
    },
    { index : 4, value : "advanced", label : t("Advanced"), initialOpen : false,
              categories : [ "attraction", "clearance", "defensiveMove", 
                "deflection", "interference", "intermezzo", "quietMove", 
                "xRayAttack", "zugzwang"
              ]
    },
    { index : 5, value : "mates", label : t("Mates"), initialOpen : false,
              categories : [ "mate", "mateIn1", "mateIn2", "mateIn3", "mateIn4",
                "mateIn5", "anastasiaMate", "arabianMate", "backRankMate", "bodenMate",
                "doubleBishopMate", "dovetailMate", "hookMate", "smotheredMate"
              ]
    },
    { index : 6, value : "special_moves" , label : t("Special Moves"), initialOpen : false,
              categories : [ "castling", "enPassant", "promotion"
              ]
    },
    { index : 7, value : "goals", label : t("Goals"), initialOpen : false,
              categories : [ "equality", "advantage", "crushing", "mate"
              ]
    },
    { index : 8, value : "lengths", label : t("Lengths"), initialOpen : false,
              categories : [ "oneMove", "twomove", "threemove", "verylong"
              ]
    },
    { index : 9, value : "origin", label : t("Origin"), initialOpen : false,
              categories : [ "master", "masterVsMaster", "superGM"
              ]},
    { index : 10, value : "pieces", label : t("Piece Count"), initialOpen : false,
              categories : [  "pieces4","pieces5","pieces6","pieces7","pieces8","pieces9",
                "pieces10","pieces11","pieces12","pieces13","pieces14","pieces15","pieces16",
                "pieces17","pieces18","pieces19","pieces20","pieces21","pieces22","pieces23",
                "pieces24","pieces25","pieces26","pieces27","pieces28","pieces29","pieces30",
                "pieces31","pieces32"
              ]},
    { index : 11, value : "opening", label : t("Opening"), initialOpen : false,
              categories : [ 
              "Alekhine_Defense","Benoni_Defense","Bird_Opening","Bishops_Opening",
              "Blackmar-Diemer_Gambit","Caro-Kann_Defense","Catalan_Opening","Center_Game",
              "Danish_Gambit","Danish_Gambit_Accepted","Dutch_Defense","Elephant_Gambit",
              "English_Defense","English_Opening","Englund_Gambit","Englund_Gambit_Complex",
              "Englund_Gambit_Declined","Four_Knights_Game","French_Defense","Grob_Opening",
              "Grunfeld_Defense","Horwitz_Defense","Hungarian_Opening","Indian_Defense",
              "Italian_Game","Kings_Gambit","Kings_Gambit_Accepted","Kings_Gambit_Declined",
              "Kings_Indian_Attack","Kings_Indian_Defense","Kings_Knight_Opening",
              "Kings_Pawn_Game","London_System","Mieses_Opening","Modern_Defense",
              "Nimzo-Indian_Defense","Nimzo-Larsen_Attack","Nimzowitsch_Defense",
              "Old_Indian_Defense","Owen_Defense","Philidor_Defense","Pirc_Defense",
              "Polish_Opening","Ponziani_Opening","Queens_Gambit_Accepted",
              "Queens_Gambit_Declined","Queens_Indian_Defense","Queens_Pawn_Game",
              "Rapport-Jobava_System","Rat_Defense","Reti_Opening","Russian_Game","Ruy_Lopez",
              "Scandinavian_Defense","Scotch_Game","Semi-Slav_Defense","Sicilian_Defense",
              "Slav_Defense","Tarrasch_Defense","Three_Knights_Opening","Trompowsky_Attack",
              "Van_Geet_Opening","Vant_Kruijs_Opening","Vienna_Game","Zukertort_Opening"
              ]}
  ]

  for (var group = 0; group < accordionLabels.length; group++) {
    var accordionLabel = accordionLabels[group]
    accordionLabel.initialOpen = false
    accordionLabel.entries = []
    for (var index = 0; index < accordionLabel.categories.length; index++) {
      const catName = accordionLabel.categories[index]
      const catNameLower = catName.toLowerCase()
      const categoryMapItem = categoryMap.get(catNameLower)

      // if category not on the database, skip it
      if (categoryMapItem == null)
        continue;

      //console.log("one item ",categoryMapItem)
      var oneItem = {
        index : index + group * 100,
        name : categoryMapItem.name,
        favorite : categoryMapItem.favorite,
        id : categoryMapItem.id,
        radio : categoryMapItem.radio
      }
      accordionLabel.entries.push(oneItem)

      // if it is a favorite, push it to the first group too
      if (categoryMapItem.favorite)
        accordionLabels[0].entries.push(oneItem)

      //console.log("COMPARE ",categoryMapItem.radio,optionDisplaySelected)
      if (categoryMapItem.radio == optionDisplaySelected) {
        if (categoryMapItem.favorite)
          accordionLabels[0].initialOpen = true
        accordionLabel.initialOpen = true
      }
    }
  }

  // make array of the groups to open initially
  var initialGroupsToOpen = []
  for (var group = 0; group < accordionLabels.length; group++) {
    if (accordionLabels[group].initialOpen)
      initialGroupsToOpen.push(accordionLabels[group].value)
  }
  if (initialGroupsToOpen.length == 0)
    initialGroupsToOpen.push("all")

  return ( { accordion : accordionLabels, initialOpenArray : initialGroupsToOpen })
}